import { Box, Button, Chip, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, } from "@mui/material";
import * as React from "react";
import "../../../scss/main.scss";
import { enqueueSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { closeWeightDisputeRequest } from "@/redux/actions";
import { getNewDateString } from "@/utils/Common";
import ClosedDisputeDetails from "./ClosedDisputeDetailDrawer";
import BackDropComponent from "@/components/BackDrop";
import { useNavigate } from "react-router";
import RejectDisputeBulkModal from "./RejectDisputeBulkModal";
// utils/dateUtils.ts
const calculateDays = (overallStatus, createdAt, batchClosedAt) => {
    if (!createdAt)
        return "-";
    let endTime;
    if (batchClosedAt === null) {
        endTime = Date.now();
    }
    else {
        endTime = batchClosedAt;
    }
    if (!endTime)
        return "-";
    const diffInMs = endTime - createdAt;
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    return `${diffInDays} ${diffInDays === 1 ? "Day" : "Days"}`;
};
const headCells = [
    {
        id: "batch_number",
        disablePadding: true,
        label: "Batch number",
    },
    {
        id: "orders",
        disablePadding: true,
        label: "Orders",
    },
    {
        id: "proof_details",
        disablePadding: true,
        label: "Proof details",
    },
    {
        id: "dispute_age",
        disablePadding: true,
        label: "Dispute age",
    },
    {
        id: "approval_status",
        disablePadding: true,
        label: "Approval status",
    },
    {
        id: "actions",
        disablePadding: true,
        label: "Actions",
    },
];
function EnhancedTableHead(props) {
    const { rowCount } = props;
    return (React.createElement(TableHead, { sx: { p: 2, width: "100%" }, style: { background: "#FAFBFC" } },
        React.createElement(TableRow, null, headCells.map((headCell) => {
            return (React.createElement(TableCell, { key: headCell.id, align: "left", className: "orderTable_heading_font", padding: "normal" }, headCell.label));
        }))));
}
const BulkDisputeComponent = ({ selectedCarriersP, setSelectedCarriersP, selectedServicesP, setSelectedServicesP, orderNumbersStrP, setOrderNumbersStrP, AWBstrP, setAWBstrP, handleFilterOpen, handleFilterClose, fetchWeightDiscrepancyData, rowsPerPage, setRowsPerPage, weightDiscrepancy, setWeightDiscrepancy, totalCount, setTotalCount, tabStatus, isFilterApplied, setIsFilterApplied, isSearchActive, }) => {
    const [discrepancies, setDiscrepancies] = React.useState([]);
    const [isDetailsSliderOpen, setIsDetailsSliderOpen] = React.useState(false);
    const [selectedRowData, setSelectedRowData] = React.useState();
    const navigate = useNavigate();
    const [isRejectModalOpen, setIsRejectModalOpen] = React.useState(false);
    const [isBackOpenOpen, setIsBackOpenOpen] = React.useState(false);
    const [page, setPage] = React.useState(0);
    const dispatch = useDispatch();
    const closeWeightDisputeState = useSelector((state) => state.closeWeightDisputeReducer);
    React.useEffect(() => {
        if (closeWeightDisputeState && closeWeightDisputeState.data && !closeWeightDisputeState.loading) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(closeWeightDisputeState.data, {
                variant: "success",
            });
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }
        else if (closeWeightDisputeState.error) {
            setIsBackOpenOpen(false);
            if (closeWeightDisputeState.error instanceof Error) {
                enqueueSnackbar(closeWeightDisputeState.error.message, {
                    variant: "error",
                });
            }
        }
    }, [closeWeightDisputeState]);
    React.useEffect(() => {
        if (weightDiscrepancy && weightDiscrepancy.length > 0) {
            setDiscrepancies((prevShipments) => {
                if (isSearchActive) {
                    return weightDiscrepancy;
                }
                else {
                    const combined = [...prevShipments, ...weightDiscrepancy];
                    return Array.from(new Set(combined.map((shipment) => shipment.batchId))).map((id) => combined.find((shipment) => shipment.batchId === id));
                }
            });
        }
        else if (isSearchActive) {
            setDiscrepancies([]);
        }
    }, [weightDiscrepancy, isSearchActive]);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        if (discrepancies.length / rowsPerPage <= newPage) {
            fetchWeightDiscrepancyData(rowsPerPage, newPage);
        }
    };
    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
        fetchWeightDiscrepancyData(newRowsPerPage, 0);
    };
    const handleRejectDispute = (selectedRowData) => {
        if (selectedRowData) {
            setSelectedRowData(selectedRowData);
            setIsRejectModalOpen(true);
        }
    };
    const handleAcceptDispute = (selectedRowData) => {
        if (selectedRowData) {
            setIsBackOpenOpen(true);
            dispatch(closeWeightDisputeRequest({
                tenantId: selectedRowData.tenantId,
                batchId: selectedRowData.batchId,
                orderIds: selectedRowData.orderIds,
                weightDisputeStatus: "accepted_by_carrier",
                carrierRejectReason: "",
                carrierRejectFileUrl: "",
            }));
        }
    };
    const handleDisputeDiscrepancy = (selectedRowData) => {
        if (selectedRowData) {
            setSelectedRowData(selectedRowData);
            setIsDetailsSliderOpen(true);
        }
    };
    const visibleRows = React.useMemo(() => {
        return discrepancies === null || discrepancies === void 0 ? void 0 : discrepancies.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    }, [discrepancies, page, rowsPerPage]);
    return (React.createElement(Grid, { container: true, direction: "row", paddingTop: 2, className: "m_background_color" },
        React.createElement(BackDropComponent, { open: isBackOpenOpen }),
        React.createElement(Grid, { className: "order_table_border", sx: { width: "100%", padding: 0, margin: 0 } },
            React.createElement(Paper, { sx: { width: "100%" } },
                React.createElement(TableContainer, null,
                    React.createElement(Table, { sx: { minWidth: 750, width: "100%" }, className: "or_table", "aria-labelledby": "tableTitle", size: "medium" },
                        React.createElement(EnhancedTableHead, { rowCount: weightDiscrepancy === null || weightDiscrepancy === void 0 ? void 0 : weightDiscrepancy.length }),
                        React.createElement(TableBody, { sx: { p: 2 } }, visibleRows && visibleRows.length > 0 ? (visibleRows.map((row, index) => {
                            const labelId = `enhanced-table-checkbox-${index}`;
                            return (React.createElement(TableRow, { hover: true, role: "checkbox", tabIndex: -1, key: row.batchId, sx: { cursor: "pointer" } },
                                React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                    React.createElement(Typography, { sx: { fontFamily: "Poppins", fontWeight: 500, fontSize: "12px", color: "#121114" }, component: "div" }, row === null || row === void 0 ? void 0 : row.batchId),
                                    React.createElement(Typography, { sx: {
                                            fontFamily: "Poppins",
                                            color: "#5F5A6B",
                                            fontSize: "10px",
                                            fontWeight: 400,
                                        }, component: "div" }, row.createdAt ? (React.createElement(React.Fragment, null,
                                        React.createElement("div", null,
                                            getNewDateString(+row.createdAt).date,
                                            " ",
                                            getNewDateString(+row.createdAt).time))) : ("-"))),
                                React.createElement(TableCell, { className: "orderTable_font", align: "left" },
                                    React.createElement(Typography, { sx: {
                                            color: "#0C77FF",
                                            fontSize: "12px",
                                            fontWeight: 500,
                                            cursor: "pointer",
                                            textDecoration: "underline",
                                        }, onClick: () => navigate("/weightdispute", {
                                            state: { selectedRow: row },
                                        }) }, row === null || row === void 0 ? void 0 : row.orderIdsCount)),
                                React.createElement(TableCell, { align: "left", className: "orderTable_font" },
                                    React.createElement(Typography, { sx: {
                                            color: "#0C77FF",
                                            fontSize: "12px",
                                            fontWeight: 500,
                                            cursor: "pointer",
                                            textDecoration: "underline",
                                        }, onClick: () => handleDisputeDiscrepancy(row) }, "View images")),
                                React.createElement(TableCell, { align: "left", className: "orderTable_font" },
                                    React.createElement(Typography, { variant: "subtitle2", component: "div", className: "orderTable_font", sx: {
                                            textAlign: "left",
                                            fontFamily: "Poppins",
                                            fontSize: "12px",
                                            color: "#5F5A6B",
                                            fontWeight: 500,
                                        } }, calculateDays(row === null || row === void 0 ? void 0 : row.overallStatus, row === null || row === void 0 ? void 0 : row.createdAt, row === null || row === void 0 ? void 0 : row.batchClosedAt))),
                                React.createElement(TableCell, { align: "left", className: "orderTable_font" },
                                    React.createElement(Typography, { className: "orderTable_font", variant: "subtitle2", component: "span", sx: { ml: 1 } }, (row === null || row === void 0 ? void 0 : row.batchClosedAt) === null ? (React.createElement(Chip, { label: "Open", variant: "outlined", size: "small", className: "tr_chip m_font_size_12", style: { color: "#E53935", backgroundColor: "#FDECEC", border: "none" } })) : (React.createElement(Chip, { label: "Closed", variant: "outlined", size: "small", className: "tr_chip m_font_size_12", style: { color: "#2B873D", backgroundColor: "#DFFCE5", border: "none" } })))),
                                React.createElement(TableCell, { align: "left", className: "orderTable_font" },
                                    React.createElement(Box, { display: "flex", flexDirection: "column", gap: 1 },
                                        React.createElement(Button, { variant: "outlined", sx: {
                                                color: "#121114",
                                                borderColor: "#121114",
                                                textTransform: "none",
                                                width: "160px",
                                                height: "28px",
                                                "&.Mui-disabled": {
                                                    color: "#9e9e9e",
                                                    borderColor: "#bdbdbd",
                                                },
                                            }, onClick: () => handleRejectDispute(row), disabled: (row === null || row === void 0 ? void 0 : row.overallStatus) === "closed" }, "Reject dispute"),
                                        React.createElement(Button, { variant: "outlined", sx: {
                                                color: "#121114",
                                                borderColor: "#121114",
                                                textTransform: "none",
                                                width: "160px",
                                                height: "28px",
                                                "&.Mui-disabled": {
                                                    color: "#9e9e9e",
                                                    borderColor: "#bdbdbd",
                                                },
                                            }, onClick: () => handleAcceptDispute(row), disabled: (row === null || row === void 0 ? void 0 : row.overallStatus) === "closed" }, "Accept dispute")))));
                        })) : (React.createElement(TableRow, null,
                            React.createElement(TableCell, { colSpan: headCells.length, align: "center", sx: { width: "100%" } }, "No data available")))))),
                React.createElement(TablePagination, { rowsPerPageOptions: [5, 10, 25], component: "div", count: totalCount, rowsPerPage: rowsPerPage, page: page, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage })),
            isDetailsSliderOpen && selectedRowData && (React.createElement(ClosedDisputeDetails, { isDetailsSliderOpen: isDetailsSliderOpen, setIsDetailsSliderOpen: setIsDetailsSliderOpen, selectedRowData: selectedRowData, handleRejectDispute: handleRejectDispute, handleAcceptDispute: handleAcceptDispute })),
            isRejectModalOpen && selectedRowData && (React.createElement(RejectDisputeBulkModal, { open: isRejectModalOpen, onClose: () => setIsRejectModalOpen(false), selectedRow: selectedRowData, setIsBackOpenOpen: setIsBackOpenOpen })))));
};
export default BulkDisputeComponent;
